import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import parseStatusCode from '../../errors/parseStatusCode';
import type { FetchAssetParams, LabelProperties } from '../types';

export interface LabelPropertiesModel {
  labelProperties: Record<string, LabelProperties>;
  labelPropertiesFailure: Action<LabelPropertiesModel, ApplicationErrorOptions>;
  fetchLabelProperties: Thunk<LabelPropertiesModel, FetchAssetParams, Injections, Promise<LabelProperties[]>>;
  setLabelProperties: Action<LabelPropertiesModel, LabelProperties[]>;
  lastAction?: number;
  labelPropertiesStart: Action<LabelPropertiesModel, void>;
}

export const labelPropertiesModel: LabelPropertiesModel = {
  labelProperties: {},
  labelPropertiesStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  labelPropertiesFailure: action((state, payload) => {
    console.error(payload);
  }),
  fetchLabelProperties: thunk(async (actions, payload, { injections }) => {
    try {
      actions.labelPropertiesStart();
      const res = await injections.assetService.fetchLabelProperties(payload);
      actions.setLabelProperties(res);
      return res;
    } catch (error) {
      actions.labelPropertiesFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured creating label augmentation.',
        asNotification: true,
      });
    }
  }),
  setLabelProperties: action((state, payload) => {
    for (const val of payload) {
      state.labelProperties[val.labelPropertiesId] = val;
    }
  }),
};
